<header class="appliance-header">
  <h1 class="appliance-header-title">{{ applianceName }}</h1>

  <!-- Right-aligned actions -->
  <div class="appliance-header-actions">
    <button mat-button color="accent" type="button" (click)="onEditAppliance()">
      Edit Core Details
    </button>
  </div>
</header>
